import React from 'react'
import Types from './types'

const QuestionForm = props => {
  switch(props.type) {
    case 'single':
      return <Types.Single {...props} />

    case 'multiple':
      return <Types.Multiple {...props} />

    default:
      return null
  }
}

export default QuestionForm
